/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React, { useLayoutEffect, useRef } from "react";

import { usePlayerAdvertisementTracker } from "../../../../../BasePlayer";

import "./Timeline.scss";

export const Timeline = () => {
  const {
    tracker: { currentTime, duration },
  } = usePlayerAdvertisementTracker();

  const progress = currentTime / duration;

  const timelineRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (timelineRef.current) {
      timelineRef.current.style.setProperty(
        "--progress-position",
        progress.toString(),
      );
    }
  }, [currentTime, progress]);

  return (
    <div className="PlayerAdTimeline" ref={timelineRef}>
      <div className="PlayerAdTimeline__ProgressArea" />
    </div>
  );
};
